import { GetStaticProps, InferGetStaticPropsType } from 'next';

import { Layout } from 'components/Layout';
import PageContent from 'components/page-content/le-nostre-app/PageContent';
import { Seo } from 'components/seo';
import { cleanConfig } from 'lib/datoCms/utils';
import { getAppsPage } from 'lib/datoCms/queries/getAppsPage';
import { getDatoCMSData } from 'sites/snai/lib/datoCms/queries/getDatoCMSData';
import { ISR_REVALIDATE } from 'utility/constant';

const LeNostreApp = ({
  site,
  title,
  footer,
  header,
  needHelp,
  leNostreAppPage,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { seoMetaTags, canonical } = leNostreAppPage ?? {};
  return (
    <Layout header={header} needHelp={needHelp} footer={footer}>
      <Seo siteSeo={site} metaTags={seoMetaTags} canonicalUrl={canonical} />
      <PageContent title={title} cardAppItems={leNostreAppPage} />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  try {
    const { site, header, needHelp, footer, allLabels: labels, config } = await getDatoCMSData('common', locale);

    const { leNostreAppPage } = await getAppsPage(locale!);

    const apps = leNostreAppPage.app.map((app) => {
      return {
        title: app.title,
        image: {
          src: app.logo.url,
        },
        heroImage: app.banner
          ? {
              src: app.banner.url,
            }
          : null,
        urlDonwloadAppIos: app.linkIos.length > 0 ? app.linkIos[0].href ?? null : null,
        urlDonwloadAppAndroid: app.linkAndroid.length > 0 ? app.linkAndroid[0].href ?? null : null,
        urlDonwloadAppAndroidLabel: app.versione,
        description: app.description,
        qrCode: app.qrcode
          ? {
              src: app.qrcode.url,
            }
          : null,
      };
    });

    return {
      props: {
        site,
        header,
        footer,
        title: leNostreAppPage.title,
        labels,
        config: cleanConfig(config),
        needHelp,
        leNostreAppPage: apps,
      },
      revalidate: ISR_REVALIDATE,
    };
  } catch (error) {
    console.log(error);
    return { notFound: true };
  }
};

export default LeNostreApp;
